import React from 'react';
import { motion } from 'framer-motion';
import { FaUserCircle } from "react-icons/fa";
import bg from '../assets/img/london_bg.webp';

const testimonials = [
  {
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people03.png",
    name: "Abigal",
    username: "jeniesabigal",
  },
  {  
    text: "Monitor pending transactions and send or receive physical checks efficiently. Stay updated on payment statuses and manage your financial activities with ease.",
    imgSrc: "/assets/icons/people01.png",
    name: "Paul Stef",
    username: "Stefanesc@11",
  },
  {
    text: "Quickly cancel unwanted transactions to avoid errors or fraud. Ensure your funds remain secure and maintain full control over your financial activities.",
    imgSrc: "/assets/icons/people02.png",
    name: "Ellen Steph",
    username: "steph-acc",
  },
  {     
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people03.png",
    name: "Aman Orely",
    username: "orley-ost",
  },
  {
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people01.png",
    name: "John Max",
    username: "maxat_joe",
  },
  {  
    text: "Monitor pending transactions and send or receive physical checks efficiently. Stay updated on payment statuses and manage your financial activities with ease.",
    imgSrc: "/assets/icons/people02.png",
    name: "Hillie Ester",
    username: "ester98me",
  },
  {
    text: "Quickly cancel unwanted transactions to avoid errors or fraud. Ensure your funds remain secure and maintain full control over your financial activities.",
    imgSrc: "/assets/icons/people03.png",
    name: "Yorn George",
    username: "gerorge",
  },
  {     
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people02.png",
    name: "Liam Kob",
    username: "kob-tmn26",
  },
  {
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people03.png",
    name: "Alexandra Lup",
    username: "lup-ale",
  },
  {  
    text: "Monitor pending transactions and send or receive physical checks efficiently. Stay updated on payment statuses and manage your financial activities with ease.",
    imgSrc: "/assets/icons/people01.png",
    name: "Bob Remus",
    username: "remus@bike",
  },
  {
    text: "Quickly cancel unwanted transactions to avoid errors or fraud. Ensure your funds remain secure and maintain full control over your financial activities.",
    imgSrc: "/assets/icons/people02.png",
    name: "Killian Ubuntu",
    username: "ubunt,alex",
  },
  {     
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people03.png",
    name: "Emilia Strautz",
    username: "butanriu98",
  },
  {
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people03.png",
    name: "Alexandra Lup",
    username: "lup-ale",
  },
  {  
    text: "Monitor pending transactions and send or receive physical checks efficiently. Stay updated on payment statuses and manage your financial activities with ease.",
    imgSrc: "/assets/icons/people01.png",
    name: "Bob Remus",
    username: "remus@bike",
  },
  {
    text: "Quickly cancel unwanted transactions to avoid errors or fraud. Ensure your funds remain secure and maintain full control over your financial activities.",
    imgSrc: "/assets/icons/people02.png",
    name: "Killian Ubuntu",
    username: "ubunt,alex",
  },
  {     
    text: "Tailor your approach to fit your unique needs. Enjoy the flexibility of customizing tasks across various platforms and enhance your process.",
    imgSrc: "/assets/icons/people03.png",
    name: "Emilia Butnariu",
    username: "butanriu98",
  }
];


const TestimonialsRow = ({ className, testimonials, duration, direction }) => {
  const repeatedTestimonials = [...testimonials, ...testimonials];

  return (
    <div className={`${className} overflow-hidden`}>
      <motion.div 
        initial={{ translateX: direction === 'right' ? 0 : '-100%' }} 
        animate={{ translateX: direction === 'right' ? '-100%' : '0%' }} 
        transition={{
          duration: duration,
          repeat: Infinity,
          ease: "linear",
        }}
        className="flex"
      >
        {repeatedTestimonials.map(({ text, imgSrc, name, username }, index) => (
          <div className='testimonial-card p-10 min-w-[400px] h-[250px] mx-2 backdrop-blur-3xl' key={index}>
            <div className='text-neutral-300 font-normal leading-5 mt-4'><p>{text}</p></div>
            <div className='flex items-center gap-2 mt-5'>
              <FaUserCircle size={35} className='text-white' />
              <div className="flex flex-col ml-3">
                <div className="font-medium tracking-tight leading-5">
                  <h2 className='text-neutral-300'>{name}</h2>
                </div>
                <div className="tracking-tight leading-5">
                  <h2 className='text-neutral-300'>{username}</h2>
                </div>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

const Testimonials = () => {
  return (
    <section className='mt-24 text-white relative'>
      <div className="testimonials-background absolute md:inset-0 [mask-image:linear-gradient(to_bottom,transparent,black,black,transparent)]">
        <img src={bg} className='object-cover' alt="" />
      </div>
      <div className="shadow-top" />
      <div className="wrapper relative">
        <div className='flex flex-col'>
          <div className='flex flex-col testimonial_header'>
            <h1 className='text-center leading-[2.5rem] text-[3.5rem] font-normal tracking-tight'>
              Testimonials
            </h1>
          </div>
          <div className="flex flex-col mt-16 gap-6 max-h-[700px] w-full mx-auto overflow-hidden [mask-image:linear-gradient(to_right,transparent,black,black,transparent)]">
            <TestimonialsRow testimonials={testimonials.slice(0, 8)} duration={20} direction="left" />
            <TestimonialsRow testimonials={testimonials.slice(8, 12)} duration={15} direction="right" className='hidden md:block' />
          </div>
        </div>
      </div>
      <div className="shadow-bottom" />
    </section>
  );
};

export default Testimonials;
